import Carousel from '../components/Carousel';
import Slider from '../components/Slider';
import { $ } from '../util/DOM';

const getLinkHtml = (el) => {
  const qs = el.getAttribute('data-link-content');
  if (!qs) {
    return '';
  }
  const content = el.querySelector(qs);
  if (!content) {
    return '';
  }
  return content.innerHTML;
};

const sliderControlComponents = {
  arrows: (slider) => $.render('div', {
    className: 'slider-controls__arrows',
    children: [
      $.render('button', {
        type: 'button',
        className: 'prev',
        attrs: { 'aria-label': 'Voltar slide' },
        innerHTML: /* html */ `
        <svg width="9" height="19" viewBox="0 0 9 19" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8.21991 17.678C8.21967 17.3798 8.11195 17.0938 7.92043 16.883L2.69858 11.1289C2.54052 10.9548 2.41515 10.748 2.3296 10.5205C2.24406 10.293 2.20004 10.0491 2.20004 9.80284C2.20004 9.55657 2.24406 9.3127 2.3296 9.08518C2.41515 8.85766 2.54052 8.65093 2.69858 8.47681L7.91362 2.72642C8.0996 2.51424 8.2025 2.23005 8.20018 1.93508C8.19785 1.6401 8.09048 1.35793 7.90119 1.14934C7.71189 0.940748 7.45582 0.82243 7.18813 0.819867C6.92044 0.817303 6.66255 0.9307 6.46999 1.13563L1.25495 6.88152C0.553731 7.65574 0.159909 8.70489 0.159909 9.79872C0.159909 10.8925 0.553731 11.9417 1.25495 12.7159L6.4768 18.4701C6.61938 18.6273 6.80102 18.7344 6.99881 18.778C7.1966 18.8216 7.40168 18.7996 7.58815 18.7149C7.77462 18.6301 7.93414 18.4865 8.04658 18.3019C8.15902 18.1174 8.21933 17.9003 8.21991 17.678Z" fill="white"/>
        </svg>
        `,
        events: {
          click: () => {
            slider.goPrev();
          },
        },
      }),
      $.render('button', {
        type: 'button',
        className: 'next',
        attrs: { 'aria-label': 'Avançar slide' },
        innerHTML: /* html */ `
        <svg width="9" height="19" viewBox="0 0 9 19" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0.219971 17.0584C0.220209 16.7601 0.32793 16.4742 0.519451 16.2634L5.7413 10.5092C5.89936 10.3351 6.02473 10.1284 6.11028 9.90088C6.19582 9.67335 6.23984 9.42949 6.23984 9.18321C6.23984 8.93694 6.19582 8.69307 6.11028 8.46555C6.02473 8.23803 5.89936 8.0313 5.7413 7.85718L0.526257 2.10679C0.340282 1.89461 0.237375 1.61042 0.239702 1.31545C0.242028 1.02047 0.349401 0.738297 0.538694 0.529708C0.727988 0.321119 0.984056 0.202801 1.25175 0.200238C1.51944 0.197675 1.77733 0.311071 1.96989 0.516004L7.18493 6.26189C7.88615 7.03611 8.27997 8.08526 8.27997 9.17909C8.27997 10.2729 7.88615 11.3221 7.18493 12.0963L1.96308 17.8504C1.8205 18.0076 1.63886 18.1148 1.44107 18.1584C1.24328 18.2019 1.0382 18.18 0.85173 18.0952C0.665257 18.0105 0.505737 17.8668 0.393301 17.6823C0.280865 17.4978 0.220551 17.2807 0.219971 17.0584Z" fill="white"/>
        </svg>
        `,
        events: {
          click: () => {
            slider.goNext();
          },
        },
      }),
    ],
  }),
  counters: (slider) => {
    const children = slider.children.map((el, i) => $.render('button', {
      type: 'button',
      textContent: i + 1,
      attrs: { 'aria-label': `Ver o slide ${i + 1}` },
      events: { click: () => slider.goTo(i) },
    }));

    slider.on('render', () => {
      children.forEach((btn, btnIndex) => {
        if (btnIndex === slider.index) {
          btn.classList.add('is-active');
        } else {
          btn.classList.remove('is-active');
        }
      });
    });

    return $.render('div', {
      className: 'slider-controls__counters',
      children,
    });
  },
  links: (slider) => {
    const children = slider.children.map((el, i) => $.render('div', {
      innerHTML: getLinkHtml(el),
      tabindex: '-1',
      events: { click: () => slider.goTo(i) },
    }));

    slider.on('render', () => {
      children.forEach((btn, btnIndex) => {
        if (btnIndex === slider.index) {
          btn.classList.add('is-active');
        } else {
          btn.classList.remove('is-active');
        }
      });
    });

    return $.render('div', {
      className: 'slider-controls__links',
      children,
    });
  },
};

const generateControls = (slider, keys) => keys.map((key) => {
  if (!(key in sliderControlComponents)) {
    // eslint-disable-next-line no-console
    console.warn(`Opção de controle inválida: ${key}. As opções disponíveis são ${
      Object.keys(sliderControlComponents).join(', ')
    }`);
    return null;
  }
  return sliderControlComponents[key](slider);
});

const setSliderControls = (slider, controlOptions) => {
  if (!controlOptions) {
    return;
  }
  const controlKeys = controlOptions.trim().split(' ');
  if (!controlKeys.length) {
    return;
  }

  const container = $.render('div', {
    className: 'slider-controls__container',
    children: generateControls(slider, controlKeys),
  });

  slider.container.insertAdjacentElement('afterEnd', container);
};

const createSlider = (container, type) => {
  const play = container.hasAttribute('data-play');
  const interval = container.getAttribute('data-interval') || 3000;
  const height = container.getAttribute('data-height');
  const controls = container.getAttribute('data-controls');

  const slider = (
    type === 'carousel'
      ? new Carousel(container, { interval })
      : new Slider(container, { interval })
  );

  if (play) {
    slider
      .on('mouseover', () => slider.pause())
      .on('mouseout', () => slider.play())
      .play();
  }

  if (height) {
    slider.container.style.height = height;
  }

  if (controls) {
    setSliderControls(slider, controls);
  }

  return slider;
};

const createCarousel = (container) => {
  createSlider(container, 'carousel');
};

const initSliders = () => {
  $('.slider').forEach(createSlider);
  $('.carousel').forEach(createCarousel);
};

export default initSliders;
